<script setup>
const props = defineProps({
    color: {
        type: String,
        default: "black",
    },
});
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
    >
        <path
            d="M7.29288 5.5L3.64645 9.14645C3.45119 9.34171 3.45119 9.65829 3.64645 9.85355L7.29288 13.5M4.54288 9.5H19.5429C20.6475 9.5 21.5429 10.3954 21.5429 11.5V16.5C21.5429 17.6046 20.6475 18.5 19.5429 18.5H12.5429"
            :stroke="color"
            stroke-width="2.5"
            stroke-linecap="round"
        />
    </svg>
</template>
